import { Suspense, lazy } from 'react';

import { createFileRoute } from '@tanstack/react-router';

const CalendarPage = lazy(() =>
  import('@/features/calendar/pages/CalendarPage').then((m) => ({ default: m.CalendarPage })),
);

function CalendarPageWrapper() {
  return (
    <Suspense fallback={<div className="p-8 text-center text-quiet">Cargando calendario...</div>}>
      <CalendarPage />
    </Suspense>
  );
}

export const Route = createFileRoute('/_app/$wsSlug/calendar')({
  component: CalendarPageWrapper,
});
